import { HierarchyUtils, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { NO_MOUNTING_RAIL, NO_UPRIGHTS } from "../constants/errors";
import { getUprights } from "../utils/sectionsHelpers";
/**
 * Get children of an upright that is attached to another insert on it's left side
 * @param upright
 */
const getAttachedInserts = (upright) => HierarchyUtils.children(upright).filter((child) => {
    const isInsert = child.hasComponent(COMPONENT_IDS.INSERT);
    const isAligned = child.hasComponent(COMPONENT_IDS.LEFT_SIDE_ATTACHED_TO) ||
        HierarchyUtils.children(child).some((grandChild) => grandChild.hasComponent(COMPONENT_IDS.LEFT_SIDE_ATTACHED_TO));
    return isInsert && isAligned;
});
/**
 * Fetches all inserts based on a given upright who has a collider will be affected by the dragging of said upright
 * @param upright
 */
export const getAffectedInserts = (upright) => [
    ...getAdjustableClothRailParts(upright),
    ...getAdjustableShelfParts(upright),
    ...getOtherInserts(upright),
];
/**
 * Gets regular inserts that are not adjustable
 * @param upright
 */
const getOtherInserts = (upright) => {
    const children = getAttachedInserts(upright);
    const adjustableShelves = children.filter((child) => !child.hasComponent(COMPONENT_IDS.ADJUSTABLE_COMPONENT));
    return adjustableShelves.flatMap((adjustableShelf) => HierarchyUtils.children(adjustableShelf));
};
/**
 * Get adjustable shelves parts
 * @param upright
 */
const getAdjustableShelfParts = (upright) => {
    const children = getAttachedInserts(upright);
    const adjustableShelves = children.filter((child) => child.hasComponent(COMPONENT_IDS.ADJUSTABLE_COMPONENT));
    return adjustableShelves.flatMap((adjustableShelf) => HierarchyUtils.children(adjustableShelf).flatMap((descendants) => HierarchyUtils.children(descendants)));
};
/**
 * Get adjustable cloth rails
 * @param upright
 */
export const getAdjustableClothRails = (upright) => {
    const mountingRail = HierarchyUtils.parent(upright);
    if (!mountingRail)
        throw new Error(NO_MOUNTING_RAIL);
    const { leftUpright } = getUprights(mountingRail);
    if (!leftUpright)
        throw new Error(NO_UPRIGHTS);
    return HierarchyUtils.descendants(leftUpright).filter((child) => child.hasComponent(COMPONENT_IDS.INSERT_ATTACHMENT_COMPONENT));
};
/**
 * get adjustable cloth rail parts
 * @param upright
 */
export const getAdjustableClothRailParts = (upright) => getAdjustableClothRails(upright).flatMap((adjustableClothRail) => HierarchyUtils.children(adjustableClothRail));
